import { useEditor } from '@tiptap/react';
import { createContext, useMemo } from 'react';

import type { RichTextEditorContextData, RichTextEditorProviderProps } from './types';
import { getExtensions } from './utils';

const RichTextEditorContext = createContext<RichTextEditorContextData | undefined>(undefined);

function RichTextEditorProvider(props: Readonly<RichTextEditorProviderProps>) {
  const { children, content = '', onImageUpload, placeholder, onChange, controls } = props;

  const extensions = useMemo(
    () => getExtensions({ onImageUpload, placeholder, controls }),
    [onImageUpload, placeholder, controls],
  );

  const editor = useEditor({
    extensions,
    content,
    onUpdate: ({ editor }) => {
      onChange?.(editor.getHTML());
    },
  });

  const contextValue = useMemo(
    () => ({
      editor,
      onImageUpload,
    }),
    [editor, onImageUpload],
  );

  return (
    <RichTextEditorContext.Provider value={contextValue}>{children}</RichTextEditorContext.Provider>
  );
}

export { RichTextEditorContext, RichTextEditorProvider };
